export class TaikyoNotificationForInput {
    inputList = [];
    accountKbnList = [];
    taikyoReasons = [];
    taikyoDateMinDays = 0;
    taikyoDateMaxDays = 0;
    taikyoMaxDate = null;
    taikyoMaxDate = null;
    tachiaishaKbnList = [];
    contactKbList = [];
}
export class Input {
    orgNyukyokeiyakuNo = -1;
    keyReturnMinTime = "00:00";
    keyReturnMaxTime = "23:59";
    keyReturnName = "";
    keyReturnNameKb = 0;
}
